import React from "react";
import Logo from "../../assets/images/logos.png";

// Reusable Button Component for consistency
const Button = ({ children, variant = "primary" }) => {
    const styles = variant === "primary"
        ? "bg-brand-orange text-white hover:bg-orange-600 shadow-lg shadow-orange-200"
        : "bg-white text-brand-dark border-2 border-gray-100 hover:border-brand-orange";

    return (
        <button className={`px-8 py-4 rounded-full font-bold transition-all transform hover:-translate-y-1 active:scale-95 ${styles}`}>
            {children}
        </button>
    );
};

const LandingPage = () => {
    return (
        <div className="min-h-screen bg-white font-sans text-slate-900 overflow-x-hidden">
            {/* Background Decorative Blob */}
            <div className="absolute top-0 right-0 -z-10 w-[500px] h-[500px] bg-brand-orange/5 rounded-full blur-3xl" />

            {/* HERO SECTION */}
            <main className="px-6 md:px-16 lg:px-24 pt-10 pb-6 md:pt-14 md:pb-8 relative">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center max-w-7xl mx-auto">
                    {/* Hero Left: Text and CTAs */}
                    <div className="space-y-8 animate-float">
                        <h1 className="text-5xl md:text-6xl font-extrabold leading-tight tracking-tighter text-brand-dark">
                            {/* Line 1 */}
                            <div
                                className="animate-fade-up [animation-delay:200ms] opacity-0 [animation-fill-mode:forwards]">
                                Apni Dukaan,
                            </div>

                            <div
                                className="animate-fade-up [animation-delay:400ms] opacity-0 [animation-fill-mode:forwards]">
                <span className="bg-brand-gradient bg-200% bg-clip-text text-transparent animate-shimmer inline-block">
                  Digital Tarike Se
                </span>
                            </div>

                            <div
                                className="animate-fade-up [animation-delay:600ms] opacity-0 [animation-fill-mode:forwards]">
                                Chalao
                            </div>
                        </h1>

                        <p className="text-lg text-gray-600 max-w-xl leading-relaxed">
                            Manage stores, track credit (udhar), handle orders & payments —
                            all from one simple app. Built for{" "}
                            <strong className="text-gray-800">Indian shopkeepers</strong> &
                            their customers.
                        </p>
                    </div>

                    {/* Hero Right: Character Illustration (Placeholder) */}
                    <div className="relative flex justify-center">
                        <div className="relative w-full max-w-md">
                            <div className="absolute inset-0 bg-brand-orange/10 rounded-3xl -rotate-3 scale-105" />
                            <img src={Logo} alt="App Preview" className="relative z-10 rounded-2xl shadow-xl border border-slate-100" />
                        </div>
                    </div>
                </div>
            </main>

            {/* FEATURES SECTION */}
            <section className="py-24 bg-slate-50">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="text-center max-w-3xl mx-auto mb-20">
                        <h2 className="text-4xl md:text-5xl font-bold mb-6">
                            Everything Your <span className="text-brand-orange underline decoration-orange-200 underline-offset-8">Dukaan</span> Needs
                        </h2>
                        <p className="text-lg text-slate-500">
                            One app to replace your registers, calculators, and stress.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {[
                            { title: "Multi-Store", desc: "Manage multiple branches seamlessly.", icon: "🏠" },
                            { title: "Smart Stock", desc: "Low stock alerts & easy inventory.", icon: "📦" },
                            { title: "Udhar Khata", desc: "Automated payment reminders via WhatsApp.", icon: "💳" },
                            { title: "Daily Reports", desc: "Clear view of your daily P&L.", icon: "📊" },
                        ].map((feature, i) => (
                            <div
                                key={i}
                                className="bg-white p-8 rounded-3xl border border-slate-200 hover:border-brand-orange transition-all hover:shadow-2xl hover:shadow-orange-100 group"
                            >
                                <div className="w-14 h-14 bg-slate-50 rounded-2xl flex items-center justify-center text-3xl mb-6 group-hover:bg-brand-orange group-hover:scale-110 transition-all">
                                    {feature.icon}
                                </div>
                                <h3 className="text-xl font-bold mb-3">{feature.title}</h3>
                                <p className="text-slate-500 leading-relaxed">{feature.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default LandingPage;